'use strict';

/**
 *
 * @name: TranslateDateFactory
 *
 */

function TranslateDateFactory($rootScope) {

  'ngInject';

  return function(date) {
 
    return (date && $rootScope.lang === 'zh-cn') ?
      moment(date).toDate().toISOString():
      date;
  };
}

export default TranslateDateFactory;



// WEBPACK FOOTER //
// ./app/components/nn-translations/nn-translate-date.factory.js